import { Stack } from '@mui/material';
import { TransactionsDetailsItem } from './TransactionsDetailsItem';
import { formatDate } from '@utils/dateUtils';
import { convertCrDrToType } from '../TransactionsTable/transactions.utils';
import React, { FC, useContext, useMemo } from 'react';
import { LocalizationContext } from '@context/LocalizationContext';
import { InvestigationTransaction, TransactionTypeEnum } from '../TransactionsTable/transactions.types';

interface TransactionsDetailsProps {
	transactionDetails: InvestigationTransaction;
	backgroundColor?: string;
}

const getOppPartyNameTitle = (
	transaction: InvestigationTransaction,
	translations: {
		sender: string;
		recipient: string;
		issuer: string;
	},
) => {
	if (
		transaction.transactionType === TransactionTypeEnum.PAYPAL_TRANSFER ||
		transaction.transactionType === TransactionTypeEnum.CASHAPP_TRANSFER ||
		transaction.transactionType === TransactionTypeEnum.ZELLE_TRANSFER
	) {
		if (transaction.crDrInd.toLowerCase() === 'cr') {
			return translations.sender;
		}
		if (transaction.crDrInd.toLowerCase() === 'dr') {
			return translations.recipient;
		}
	}

	//Check in
	if (
		(transaction.transactionType === TransactionTypeEnum.CHECK ||
			transaction.transactionType === TransactionTypeEnum.CHECK_DEPOSIT) &&
		transaction.crDrInd.toLowerCase() === 'cr'
	) {
		return translations.issuer;
	}
	//Check out
	if (
		(transaction.transactionType === TransactionTypeEnum.CHECK ||
			transaction.transactionType === TransactionTypeEnum.CHECK_DEPOSIT) &&
		transaction.crDrInd.toLowerCase() === 'dr'
	) {
		return translations.recipient;
	}

	return null;
};

export const TransactionsDetails: FC<TransactionsDetailsProps> = ({ transactionDetails, backgroundColor = 'none' }) => {
	const {
		TransactionDetails: {
			AccountTitle,
			AmountTitle,
			DateTitle,
			DescriptionTitle,
			TypeTitle,
			MoneyIn,
			MoneyOut,
			Sender,
			Recipient,
			Issuer,
		},
	} = useContext(LocalizationContext);

	const oppPartyNameTitle = useMemo(
		() =>
			getOppPartyNameTitle(transactionDetails, {
				sender: Sender,
				recipient: Recipient,
				issuer: Issuer,
			}),
		[transactionDetails],
	);
	const { crDrInd, transactionType, executionLocalDateTime, description, accountKey, acctCurrAmount, oppWireParty } =
		transactionDetails;

	console.log(executionLocalDateTime);

	return (
		<Stack
			sx={{
				backgroundColor: backgroundColor,
				padding: '16px',
			}}>
			<Stack
				gap={{
					xs: '25px',
					sm: '25px',
					md: '120px',
					lg: '120px',
					xl: '120px',
				}}
				flexDirection={'row'}>
				<Stack
					flexDirection={{
						xs: 'column',
						sm: 'row',
						md: 'row',
						lg: 'row',
						xl: 'row',
					}}
					gap={{
						xs: '20px',
						sm: '20px',
						md: '120px',
						lg: '120px',
						xl: '120px',
					}}>
					<TransactionsDetailsItem title={AmountTitle} value={`$${acctCurrAmount.toString()}`} />
					<TransactionsDetailsItem title={DateTitle} value={formatDate(executionLocalDateTime)} />
					<TransactionsDetailsItem title={AccountTitle} value={accountKey} />
				</Stack>
				<Stack
					flexDirection={{
						xs: 'column',
						sm: 'row',
						md: 'row',
						lg: 'row',
						xl: 'row',
					}}
					gap={{
						xs: '20px',
						sm: '20px',
						md: '120px',
						lg: '120px',
						xl: '120px',
					}}>
					<TransactionsDetailsItem
						title={DescriptionTitle}
						value={transactionType ? transactionType : description}
					/>
					<TransactionsDetailsItem
						title={TypeTitle}
						value={convertCrDrToType(crDrInd, {
							moneyIn: MoneyIn,
							moneyOut: MoneyOut,
						})}
					/>
					{oppPartyNameTitle && (
						<TransactionsDetailsItem title={oppPartyNameTitle} value={oppWireParty ?? ''} />
					)}
				</Stack>
			</Stack>
		</Stack>
	);
};
